import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';

/*** STYLING ***/
export const Container = styled.div`
  background: ${color('bg')};
  margin: 0;
`;

export const Text = styled.div`
  color: ${color('gray5')};
  padding-bottom: 32px;
  ${font('body-md-light')};
`;

export const FormWrapper = styled.div<{ $isOpen: boolean }>`
  transition: all 0.5s ease-in-out;
  height: 100%;
  opacity: ${({ $isOpen }) => ($isOpen ? '1.0' : '0.0')};
  width: 408px;
  transform: ${({ $isOpen }) => ($isOpen ? 'translateX(0)' : 'translateX(100%)')};
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  background-color: #fff;
  overflow: scroll;
  padding: 0;
  border-left: 1px solid ${color('gray2')};
  z-index: 9999;
  box-shadow: -16px 0px 107px 4px rgba(0, 0, 0, 0.05);
  @media screen and (${query.below('tablet')}) {
    width: ${({ $isOpen }) => ($isOpen ? '100%' : '0')};
  }
`;

export const FormInner = styled.div`
  position: relative;
  padding: 20px;

  @media screen and (${query.atLeast('tablet')}) {
    padding: 24px 34px;
  }
`;
export const FormTrigger = styled.div`
  cursor: pointer;
  button {
    @media screen and (${query.below('tablet')}) {
      width: -webkit-fill-available;
      padding: 10px 20px;
    }
  }
`;

export const InputField = styled.input<{ $isError?: boolean }>`
  ${font('body-md')};
  color: ${color('fg')};
  display: inline-block;
  outline: none;
  border-radius: 4px;
  border: 1px solid ${({ $isError }) => ($isError ? color('cta') : color('gray2'))};
  width: calc(100% - 49px);
  height: 25px;
  padding: 7px 20px 8px 16px;
  background: ${color('bg')};
  margin-bottom: 10px;
  &::placeholder {
    ${font('body-md-light')};
    color: ${color('gray4')};
  }
  &:focus {
    color: ${color('fg')};
    border: 1px solid ${color('fg')};
  }

  @media screen and (${query.below('tablet')}) {
    width: calc(100% - 40px);
    &::placeholder {
      ${font('body-sm-light')};
    }
  }
`;

export const MessageField = styled.textarea<{ $isError?: boolean }>`
  ${font('body-md')};
  color: ${color('fg')};
  padding: 12px 20px 10px 16px;
  resize: none;
  display: inline-block;
  background: ${color('bg')};
  border-radius: 4px;
  border: 1px solid ${({ $isError }) => ($isError ? color('cta') : color('gray2'))};
  width: calc(100% - 49px);
  height: 80px;
  margin-bottom: 5px;
  outline: none;
  &::placeholder {
    ${font('body-md-light')};
    color: ${color('gray4')};
  }
  &:focus {
    color: ${color('fg')};
    border: 1px solid ${color('fg')};
  }
  @media screen and (${query.below('tablet')}) {
    width: calc(100% - 40px);
    &::placeholder {
      ${font('body-sm-light')};
    }
  }
`;

export const Header = styled.div`
  ${font('headline-xs')};
  padding-top: ${space('x12')};
  padding-bottom: ${space('x7')};
  @media screen and (${query.below('tablet')}) {
    ${font('headline-xxs')};
    padding-top: 61px;
    padding-bottom: ${space('x6')};
  }
`;

export const DisclaimerContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 32px;

  .ant-checkbox-inner {
    height: 20px;
    width: 20px;
  }
`;

export const DisclaimerText = styled.p`
  color: ${color('gray4')};
  ${font('body-xs-light')};
`;

export const AdvisorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`;

export const AgentInfo = styled.div`
  flex: 1 0 0%;
`;

export const AdvisorHeadshotWrapper = styled.div`
  flex: 0 0 auto;
  width: calc(${space('x12')} - ${space('sm')});
  margin-right: ${space('md')};
`;
export const InfoBlock = styled.div<{ $bold?: boolean }>`
  ${font('body-md')};
  margin-bottom: 0px;
  font-weight: ${({ $bold }) => ($bold ? '700' : '300')};
  font-size: ${({ $bold }) => ($bold ? '18px' : '16px')};
  @media screen and (${query.below('tablet')}) {
    font-size: ${({ $bold }) => ($bold ? '16px' : '14px')};
  }
`;

export const CloseTrigger = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
`;

export const TwoColumnInputWrapper = styled.div`
  display: flex;
  @media screen and (${query.below('tablet')}) {
    flex-direction: column;
  }
`;

export const Box = styled.div`
  width: 100%;
`;

export const FormFinished = styled.div`
  padding-top: 182px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const SVGWrapper = styled.div`
  width: 100%;
  max-width: 132px;
  margin: 0 auto ${space('x8')};

  @media screen and (${query.below('tablet')}) {
    margin-bottom: ${space('x10')};
  }

  svg {
    width: 100%;
    height: auto;
  }
`;
export const Headline = styled.h2`
  ${font('headline-xs')};
  text-align: center;
`;
export const SuccessDescription = styled.div`
  ${font('body-md-light')};
  text-align: center;
  padding-bottom: calc(${space('x10')} - ${space('xs')});
`;
export const SuccessBtnGroup = styled.div`
  display: flex;
  gap: 20px;

  justify-content: center;
  flex-wrap: wrap;
`;
export const FormMain = styled.div`
  background: #ffffff;
  padding: 24px 0px 64px;
  position: relative;
  box-sizing: border-box;
  /* overflow-y: scroll; */
  /* overflow-x: hidden; */
  -webkit-flex: 1;
`;
export const BtnWrapper = styled.div`
  position: sticky;
  bottom: 0px;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px -4px 4px 0px rgb(0 0 0 / 8%);
  padding: 24px;
  box-sizing: border-box;
  z-index: 2;

  button {
    span {
      justify-content: center;
    }
  }
`;
